import { Action, Dispatch } from 'redux'
import { BreadType } from 'types/bread'
import { db } from 'firebase/index'
import { fetchBreadAction } from 'reducks/bread/actions'

const fetchBread = (breadId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const bread: BreadType | undefined = await db
      .collection('breads')
      .doc(breadId)
      .get()
      .then((snapshot) => {
        const data = snapshot.data() as BreadType
        data.bread_ref = snapshot.ref
        return data
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
    if (!bread) return
    dispatch(fetchBreadAction(bread))
  }
}

export default fetchBread
